import { render, staticRenderFns } from "./Sticker.vue?vue&type=template&id=e317a41e&scoped=true&"
import script from "./Sticker.vue?vue&type=script&setup=true&lang=js&"
export * from "./Sticker.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Sticker.vue?vue&type=style&index=0&id=e317a41e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e317a41e",
  null
  
)

export default component.exports